import React from "react";

import { H6TagStyle } from "./TextStyles.style";

export type H6Color = "black" | "gray" | "blue";
interface H6TagProps {
  color?: H6Color;
  children: any;
  margin?: any;
}

const H6Tag: React.FC<H6TagProps> = ({ children, margin, color }) => {
  return (
    <H6TagStyle style={{ "--color": color, "--margin": margin }}>
      {children}
    </H6TagStyle>
  );
};

export default H6Tag;
